const API_BASE = process.env.VUE_APP_API_BASE;
const API_KEY = process.env.VUE_APP_API_KEY;

export const createPaymentIntent = async (amount, username) => {
  try {
    const url = `${API_BASE}/v1/payment-intents`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: API_KEY,
      },
      body: JSON.stringify({
        customer: {
          externalCustomerId: username,
        },
        paymentIntent: {
          externalPaymentIntentId: `demo_${Math.floor(Date.now())}`,
          amount: `${amount}`,
          currency: "USD",
        },
      }),
    });

    if (!response.ok) {
      throw new Error(
        `Error response for payment intent: ${response.statusText}`,
      );
    }

    return await response.json();
  } catch (error) {
    console.error(`Error creating payment intent: ${response.error}`, error);
    throw error;
  }
};

export const createDisbursementIntent = async (disbursementIntentData) => {
  try {
    const url = `${API_BASE}/v1/disbursement-intents`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: API_KEY,
      },
      body: JSON.stringify(disbursementIntentData),
    });

    if (!response.ok) {
      throw new Error(
        `Error creating disbursement intent: ${response.statusText}`,
      );
    }

    return await response.json();
  } catch (error) {
    console.error("Error creating disbursement intent:", error);
    throw error;
  }
};

export const getPendingWithdraws = async () => {
  try {
    const url = `${API_BASE}/v1/disbursements/pending-validation`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: API_KEY,
      },
    });

    if (!response.ok) {
      throw new Error(
        `Error fetching pending withdraws: ${response.statusText}`,
      );
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching pending withdraws:", error);
    throw error;
  }
};

export const proceedDisbursement = async (externalDisbursementId, allow) => {
  try {
    const url = `${API_BASE}/v1/disbursements/${externalDisbursementId}/proceed/${allow}`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: API_KEY,
      },
    });

    if (!response.ok) {
      throw new Error(`Error proceeding disbursement: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error proceeding disbursement:", error);
    throw error;
  }
};

export const getPaymentStatus = async (externalPaymentIntentId) => {
  try {
    const url = `${API_BASE}/v1/payment-intents/${externalPaymentIntentId}/status`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: API_KEY,
      },
    });
    if (!response.ok) {
      throw new Error(`Error fetching payment status: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching payment status:", error);
    throw error;
  }
};

export const getVivamoCustomer = async (externalCustomerId) => {
  try {
    const url = `${API_BASE}/v1/customers/${externalCustomerId}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: API_KEY,
      },
    });

    if (!response.ok) {
      throw new Error(`Error fetching customer: ${response.statusText}`);
    }

    return await response.json();
  } catch {
    console.log("Customer does not exist");
    return null;
  }
};

export const createVivamoCustomer = async (customerData) => {
  try {
    const url = `${API_BASE}/v1/customers`;

    const data = {
      email: customerData.email,
      dateOfBirth: customerData.dateOfBirth,
    };

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: API_KEY,
      },
      body: JSON.stringify({
        externalCustomerId: customerData.username,
        data,
      }),
    });
    if (!response.ok) {
      // Try to parse the error response body to extract message
      let errorMessage = `Error creating customer: ${response.statusText}`;
      let apiMessage = null;
      try {
        const errorData = await response.json();
        if (errorData.message) {
          apiMessage = errorData.message;
          errorMessage = errorData.message;
        }
      } catch {
        // Response body is not JSON, use default error message
      }
      const error = new Error(errorMessage);
      error.statusCode = response.status;
      error.apiMessage = apiMessage;
      throw error;
    }
    return await response.json();
  } catch (error) {
    console.error("Error creating customer:", error);
    throw error;
  }
};

export const getCustomerKycInfo = async (externalCustomerId) => {
  try {
    const url = `${API_BASE}/v1/customers/${externalCustomerId}/kyc-info`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: API_KEY,
      },
    });

    if (!response.ok) {
      throw new Error(`Error fetching KYC info: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching KYC info:", error);
    throw error;
  }
};
